import Vue from 'vue'

export default {
    storeWarnings(state, warnings) {
        Vue.set(state, 'warnings', warnings)
    },
    resetNewWarning(state) {
        Vue.set(state, "newWarning", {
            color: null,
            public: "1"
        })
    },
    clearWarnings(state) {
        Vue.set(state, 'warnings', [])
        Vue.set(state, 'warning_pages', 0)
    },
    none() {
    }
}
